import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Heart, Loader2, Sparkles } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useLang } from "@/context/LanguageContext";
import api, { API } from "@/lib/api";

export default function Gallery() {
  const { t } = useLang();
  const [couples, setCouples] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/gallery").then(({ data }) => setCouples(data.couples || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#FAF6F0]">
      <Navbar />
      <main className="flex-1 max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-amber-500/10 border border-amber-500/30 px-4 py-1.5 text-amber-800 text-xs uppercase tracking-[0.2em]">
            <Sparkles className="h-3.5 w-3.5" /> {t("honour_gallery")}
          </span>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl brand-gradient-text" data-testid="gallery-title">{t("honour_gallery")}</h1>
          <p className="mt-3 text-slate-600 max-w-2xl mx-auto">{t("gallery_desc")}</p>
        </div>

        {loading ? (
          <div className="mt-16 text-center text-slate-400"><Loader2 className="h-6 w-6 animate-spin mx-auto" /></div>
        ) : couples.length === 0 ? (
          <div className="mt-16 text-center text-slate-400" data-testid="gallery-empty">{t("gallery_empty")}</div>
        ) : (
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {couples.map((c, i) => (
              <motion.div key={c.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.05 }}
                className="rounded-2xl bg-white border border-amber-500/20 overflow-hidden shadow-[0_4px_20px_-4px_rgba(139,30,43,0.08)]" data-testid={`gallery-card-${i}`}>
                {c.has_photo ? (
                  <div className="h-56 w-full overflow-hidden bg-amber-50">
                    <img src={`${API}/gallery/${c.id}/photo`} alt="Celebration" loading="lazy" className="h-full w-full object-cover" data-testid={`gallery-photo-${i}`} />
                  </div>
                ) : (
                  <div className="h-56 w-full grid place-items-center bg-gradient-to-b from-[#0A2540] to-[#8B1E2B]">
                    <Heart className="h-12 w-12 text-[#D4AF37]" fill="currentColor" />
                  </div>
                )}
                <div className="p-6 text-center">
                  <div className="font-serif text-2xl text-slate-900">
                    {c.groom_name || "—"} <span className="text-[#D4AF37]">&</span> {c.bride_name || "—"}
                  </div>
                  <div className="mt-1 text-xs uppercase tracking-widest text-amber-700">Couple #{i + 1}</div>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
